module.exports = __webpack_public_path__ + "27ce84128eaf2be48a1ab5a8e95ad9bc.png";